import { BaseModel } from "../../core/src/model/BaseModel";
import { IVendorData } from "./IVendorData";
import { IFreeGamesVendorData } from "./IFreeGamesVendorData";
import App from "../../core/src/App";


class VendorModel extends BaseModel<IVendorData> {
    public grids = {};
    public playId = "";
    public freeGames:IFreeGamesVendorData = null;
    protected _inFreeGames = false;
    public hasFreeGamesExpired = false;
    public hasFreeGamesExpiredDuringFreespins = false;
    public spinStartTime = 0;
    public autoplayDelay: number = 0.2;
    public _allowSwipeSpin: boolean = true;
    public _allowSkipIntro: boolean = false;
    public _fastPlayOn: boolean = true;


    public get fastPlayOn() {
        return this._fastPlayOn;
    }
    
    public set fastPlayOn(value: boolean) {
        this._fastPlayOn = value;
    }

    public get allowSkipIntro() {
        return this._allowSkipIntro;
    }
    
    public set allowSkipIntro(value: boolean) {
        this._allowSkipIntro = value;
    }

    public get allowSwipeSpin() {
        return this._allowSwipeSpin;
    }
    
    public set allowSwipeSpin(value: boolean) {
        this._allowSwipeSpin = value;
    }

}

export default new VendorModel();

